import { render, staticRenderFns } from "./video-preview-modal.vue?vue&type=template&id=4aa95e7f&scoped=true"
import script from "./video-preview-modal.vue?vue&type=script&lang=js"
export * from "./video-preview-modal.vue?vue&type=script&lang=js"
import style0 from "./video-preview-modal.vue?vue&type=style&index=0&id=4aa95e7f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa95e7f",
  null
  
)

export default component.exports